import React from 'react';

const FormGroupCheckbox = (props) => {
    return (
        <div className={'form-group'}>
            <div className={props.leftClassName}>
                <label className={"solicitor-form-labels"}>
                    {props.label}
                </label>
            </div>
            <div className={props.centerClassName}>
                {
                    props.disabled?
                        <div>
                            <input
                                id={props.name}
                                type="checkbox"
                                className="custom-checkbox--disabled"
                                checked={props.checked}
                                name={props.name}
                            />
                            <label htmlFor={props.name}></label>
                        </div>
                        :
                        <div>
                            <input
                                id={props.name}
                                type="checkbox"
                                className={"appFormRefSettings-check_box"}
                                checked={props.checked}
                                name={props.name}
                                onChange={props.handleChange}/>
                            <label htmlFor={props.name}></label>
                        </div>
                }
            </div>
            <div className={props.rightClassName}>

            </div>
        </div>
    )
};

export default FormGroupCheckbox;